/**
 * Updates product price when the visitor changes variant options,
 * without a page reload. Complements theme.js and Bold Commerce PRE.
 */
(function () {
  const productRoot = document.querySelector('[data-section-type="product"]');
  if (!productRoot) return;

  const sectionId = productRoot.dataset.sectionId;
  const productJsonEl = document.getElementById("ProductJson-" + sectionId);
  if (!productJsonEl) return;

  let product;
  try {
    product = JSON.parse(productJsonEl.textContent);
  } catch (e) {
    return;
  }

  const moneyFormat = window.theme && window.theme.moneyFormat;
  const strings =
    (window.theme && window.theme.strings && window.theme.strings.products && window.theme.strings.products.product) ||
    {};

  function formatMoney(cents) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    cents = parseInt(cents, 10);
    if (isNaN(cents)) return "";

    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = moneyFormat || "${{amount}}";
    const match = formatString.match(placeholderRegex);
    if (!match) return (cents / 100).toFixed(2);

    const number = (cents / 100).toFixed(2);
    const parts = number.split(".");
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    const centsPart = parts[1] ? "." + parts[1] : "";

    switch (match[1]) {
      case "amount_no_decimals":
        return dollars;
      case "amount_with_comma_separator":
        return dollars.replace(/,/g, ".") + (parts[1] ? "," + parts[1] : "");
      case "amount_no_decimals_with_comma_separator":
        return dollars.replace(/,/g, ".");
      case "amount_with_apostrophe_separator":
        return dollars.replace(/,/g, "'") + centsPart;
      default:
        return dollars + centsPart;
    }
  }

  function syncVariantId(variant) {
    if (!variant) return;
    const idInput = productRoot.querySelector('[name="id"]');
    if (!idInput || String(idInput.value) === String(variant.id)) return;
    idInput.value = variant.id;
    idInput.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function resolveVariantPriceContent(variant, retailPriceContent) {
    if (!variant || !window.BOLD || !window.BOLD.pre) {
      return retailPriceContent;
    }

    try {
      const api = window.BOLD.pre;
      syncVariantId(variant);

      const boldProduct =
        typeof api.getProductByVariantId === "function" ? api.getProductByVariantId(variant.id) : null;

      if (boldProduct) {
        const boldVariant = boldProduct.variants
          ? boldProduct.variants.find(function (v) {
              return v.id === variant.id;
            })
          : boldProduct;
        const boldPrice = boldVariant && (boldVariant.price ?? boldVariant.final_price);
        if (boldPrice != null && typeof api.formatAmount === "function") {
          return api.formatAmount(boldPrice);
        }
      }

      if (typeof api.getPriceByProductId === "function" && product.id) {
        const boldPrice = api.getPriceByProductId(product.id);
        if (boldPrice != null && typeof api.formatAmount === "function") {
          return api.formatAmount(boldPrice);
        }
      }
    } catch (e) {}

    return retailPriceContent;
  }

  function getSelectedVariant() {
    const optionSelects = productRoot.querySelectorAll('select[name^="options"]');

    if (optionSelects.length) {
      const selectedOptions = Array.from(optionSelects).map(function (select) {
        return select.value;
      });
      return (
        product.variants.find(function (variant) {
          return variant.options.every(function (option, index) {
            return option === selectedOptions[index];
          });
        }) || null
      );
    }

    const variantSelect = productRoot.querySelector("[data-variant-select]");
    if (variantSelect) {
      const variantId = parseInt(variantSelect.value, 10);
      return (
        product.variants.find(function (variant) {
          return variant.id === variantId;
        }) || null
      );
    }

    return product.variants[0] || null;
  }

  function updatePrices(variant) {
    const priceElements = productRoot.querySelectorAll("[data-price]");
    const compareElements = productRoot.querySelectorAll("[data-compare-price]");
    const priceContainer = productRoot.querySelector(".product__price-and-ratings");
    const unavailable = strings.unavailable || "Unavailable";

    if (!variant) {
      priceElements.forEach(function (el) {
        el.innerHTML = unavailable;
      });
      compareElements.forEach(function (el) {
        el.innerHTML = "";
      });
      if (priceContainer) priceContainer.setAttribute("data-show-price", "false");
      return;
    }

    let showPrice = true;
    let priceContent = formatMoney(variant.price);

    if (priceContainer) {
      const zeroPriceDisplay = priceContainer.dataset.zeroPriceDisplay;
      const customPriceContent = priceContainer.dataset.customPriceContent;

      if (variant.compare_at_price === null && variant.price === 0) {
        if (zeroPriceDisplay === "hide") {
          showPrice = false;
        } else if (zeroPriceDisplay === "replace" && customPriceContent) {
          priceContent = customPriceContent;
        }
      }

      priceContainer.setAttribute("data-show-price", showPrice ? "true" : "false");
    }

    priceContent = resolveVariantPriceContent(variant, priceContent);

    priceElements.forEach(function (el) {
      el.innerHTML = priceContent;
    });

    compareElements.forEach(function (el) {
      el.innerHTML =
        variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price) : "";
    });
  }

  function onVariantChange(variant) {
    syncVariantId(variant);
    updatePrices(variant);
  }

  document.addEventListener("product:variant-change", function (evt) {
    if (!evt.detail || !evt.detail.variant) return;
    onVariantChange(evt.detail.variant);
  });

  productRoot.querySelectorAll('select[name^="options"], [data-variant-select]').forEach(function (el) {
    el.addEventListener("change", function () {
      onVariantChange(getSelectedVariant());
    });
  });
})();
